import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ApiResponseModel } from '../../../models/core/api-response.model';
import { ChangeEmailPhoneModel } from '../../../models/core/change-email-phone.model';
import { PostValueResponseModel } from '../../../models/core/post-value-response.model';
import { ShareholderInfomaterialModel } from '../../../models/shareholder-infomaterial.model';
import { ShareholdersResource } from '../../../services/resources/shareholders.resource';
import { ChangeEmailPhoneComponent } from '../../dialogs/change-email-phone/change-email-phone.component';

@Component({
    selector: 'sl-infomaterial',
    templateUrl: './infomaterial.component.html',
    styleUrls: ['./infomaterial.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfomaterialComponent implements OnInit {
    infomaterials: ShareholderInfomaterialModel[] = [];
    isLoading = true;

    private readonly matDialog = inject(MatDialog);
    private readonly shareholdersResource = inject(ShareholdersResource);

    ngOnInit(): void {
        this.reloadInfomaterials();
    }

    onChange(item: ShareholderInfomaterialModel): void {
        item.isSelected = !item.isSelected;

        if (item.isSelected) {
            if (item.requiresEmailConfirmation) {
                const dialogRef = this.matDialog.open(ChangeEmailPhoneComponent, {
                    minWidth: '30%',
                    data: new ChangeEmailPhoneModel({ validateEmailOnly: true })
                });

                dialogRef.afterClosed().subscribe(isDone => {
                    if (isDone) {
                        this.isLoading = true;
                        this.selectInfomaterial(item.id).subscribe(() => this.reloadInfomaterials());
                    } else {
                        item.isSelected = false;
                    }
                });

                return;
            }

            this.selectInfomaterial(item.id).subscribe();
        } else {
            this.shareholdersResource.unselectInfomaterialForCurrent(item.id).subscribe();
        }
    }

    private selectInfomaterial(id: string): Observable<ApiResponseModel<PostValueResponseModel>> {
        return this.shareholdersResource.selectInfomaterialForCurrent(id);
    }

    private reloadInfomaterials(): void {
        this.shareholdersResource.getInfomaterialForCurrent().subscribe(r => {
            this.isLoading = false;
            this.infomaterials = r.value;
        });
    }
}
